import type { HelpFile } from '../../types/help'
import { FieldCardTestIds } from '../../../testids/FieldCardTestIds'

export const fieldCardHelp: HelpFile = {
  docPage: '/docs/admin/form-layouts',
  texts: {
    [FieldCardTestIds.fieldCardRemoveBtn]: 'Remove this field from the layout — the attribute definition itself is not deleted.',
  },
}
